<!--
 * @Author: your name
 * @Date: 2020-08-28 11:55:14
 * @LastEditTime: 2020-09-30 15:23:40
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \fontend_old_wap\src\components\subject.vue
-->
<template>
  <div class="onlylist" v-if="zhuanti.item.length != 0">
    <div style="background: transparent" class="plate col-fff">
      <router-link
        :to="{ path: '/goodsList', query: { id: zhuanti.clas_id, stype: 1 } }"
        class="mui-navigate-right"
      >
        <div :class="zhuanti.is_image == 1 ? 'height0' : 'height'" class="title">
          <!-- <span class="titleDot theme-bg"></span> -->
          <div class="title-left">
            <h3>{{ zhuanti.name }}</h3>
            <span class="subtitle">{{ zhuanti.subheading }}</span>
          </div>

          <div class="title-right">更多<van-icon name="arrow" color="rgba(38, 38, 38, 0.5)" /></div>
        </div>
      </router-link>

      <div :class="zhuanti.item.length == 0 ? 'height0' : 'height'" class="listGoods">
        <div v-for="(item, index) in zhuanti.item" :key="index" class="article">
          <router-link :to="{ path: '/goodslist/goods', query: { id: item.id } }">
            <div class="img-bg">
              <img
                :src="item.image == null ? '/static/errorimg1.png' : item.image"
                onerror="src='/static/errorimg1.png'"
              />
            </div>

            <div class="product-detail">
              <span class="product-name">
                <span class="tagbox">
                  <span class="tag xl" v-if="item.source == 4"> 一乡一物 </span>
                  <span class="tag xl" v-if="item.source == 3">卡券</span>
                  <span class="tag zc" v-if="item.source == 2">直充</span>
                  <span plain class="tag jd" v-if="item.source == 1">优选</span>
                  <span class="tag yx" v-if="item.source == 6">严选</span>
                </span>
                <span>{{ item.name }}</span>
              </span>
              <p class="product-price">
                <span class="theme-col">{{ item.price_points }}</span>
                <span class="ft12 theme-col">{{ $store.state.unitinfo.name }}</span>
                <p class="product-price" v-if="item.price_cash">
                  <span class="theme-col">+{{ item.price_cash }}</span>
                  <span class="ft12">元</span>
                </p>
              </p>

              <p class="product-price" v-if="stockShow && item.stock_status">
                <span
                  style="font-size: 0.24rem; color: #9d9d9d"
                >
                  库存：{{ item.stock_number }}
                </span>
              </p>

              <p class="product-price" v-if="false">
                <span
                  style="font-size: 0.24rem; text-decoration: line-through; color: #9d9d9d"
                  v-if="$store.state.webCount.market_status == 1 && item.market_price != undefined"
                >
                  市场价:{{ item.market_price }}元
                </span>
              </p>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "onlylist",
  props: {
    zhuanti: {}
  },
  data() {
    return {};
  },
  computed: {
    stockShow: function() {
      return this.$store.state.mallStockShow;
    }
  },
  methods: {
    getdatas() {}
  },
  created() {}
};
</script>
<style lang="less" scoped>
.onlylist {
  width: calc(100% - 0.4rem);
  height: auto;
  margin: 0 auto;
  background: #ffffff;
  box-shadow: 0rem 0.04rem 0.32rem 0rem #edeef6;
  border-radius: 0.16rem;
  overflow: hidden;

  .title {
    width: 100%;
    height: 0.9rem;
    box-sizing: border-box;
    padding: 0 0.2rem;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title-left {
      display: flex;
      align-items: flex-end;

      h3 {
        font-size: 0.32rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: #262626;
        line-height: 0.44rem;
      }

      .subtitle {
        font-size: 0.24rem;
        font-weight: 400;
        color: rgba(38, 38, 38, 0.5);
        line-height: 0.32rem;
        margin-left: 0.16rem;
      }
    }

    .title-right {
      display: flex;
      align-items: center;
      font-size: 0.24rem;
      font-weight: 400;
      color: rgba(38, 38, 38, 0.5);
      line-height: 0.42rem;
    }
  }

  .listGoods {
    width: 100%;
    box-sizing: border-box;
    padding: 0 0.2rem;
    margin-top: 0.24rem;
    display: flex;
    flex-wrap: wrap;
    // padding-bottom: 0.1rem;
    // 隐藏滚动条
    &::-webkit-scrollbar {
      height: 0 !important;
      width: 0 !important;
    }

    .article {
      width: 1.92rem;
      min-height: 3.4rem;
      padding-right: 0.44rem;
      margin-bottom: 0.2rem;
      display: flex;
      justify-content: center;

      &:nth-child(3n) {
        padding-right: 0;
      }

      .img-bg {
        width: 100%;
        height: auto;

        img {
          width: 1.92rem;
          height: 1.92rem;
          border-radius: 0.12rem;
        }
      }

      .product-detail {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        .product-name {
          // min-height: 0.65rem;
          height: 0.725rem;
          font-size: 0.26rem;
          font-weight: bold;
          color: #262626;
          line-height: 0.36rem;
          margin-top: 0.2rem;
          // margin-bottom: 0.08rem;
          overflow: hidden;
          text-overflow: ellipsis;
          word-break: break-all;
          -webkit-box-orient: vertical;
          display: -webkit-box;
          display: -moz-box;
          display: box;
          -webkit-line-clamp: 2; //共显示几行，再多就是省略号
          -moz-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
          -moz-box-orient: vertical;
          box-orient: vertical;
        }

        .product-price {
          padding-top: 0.08rem;
          font-size: 0.24rem;
          font-weight: 400;
          color: #fe5c42;
          line-height: 0.4rem;
          display: flex;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/subject1.vue